import script from "./Opdampage.vue?vue&type=script&setup=true&lang=js"
export * from "./Opdampage.vue?vue&type=script&setup=true&lang=js"

import "./Opdampage.vue?vue&type=style&index=0&id=ca29de5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca29de5c"]])

export default __exports__